import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import classnames from 'classnames';

export default class MenuAbout extends React.Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    const parentCloseFuncCall = this.props.parentCloseFuncCall;
  }

  handleCategoryLinkClick = (e) => {
    this.parentCloseFuncCall();
  }

  aboutMenuObj = [
    {
      name: 'What We Do',
      url: '/what-we-do',
      slug: 'what-we-do',
      isExternalUrl: false
    },
    {
      name: 'Meet the Team',
      url: '/pages/meet-the-team',
      slug: 'meet-team',
      isExternalUrl: false
    },
    {
      name: 'Contact',
      url: '/pages/contact',
      slug: 'contact',
      isExternalUrl: false
    },
    {
      name: 'WorldWideWomen Foundation',
      url: 'http://www.worldwidewomenfoundation.org/',
      slug: 'worldwidewomen-foundation',
      isExternalUrl: true
    },
  ];

  handleAboutLinkClick = (e) => {
    this.parentCloseFuncCall();
  }

  render() {
    const { aboutMenuState, browser } = this.props;

    let linkPath = '';
    let iconPath = '';
    let menuLinks = this.aboutMenuObj.map(menuLink => {
      linkPath = menuLink.url;
      if (menuLink.isExternalUrl) {
        return <li key={menuLink.slug}>
          <div className="mainMenu-subNavLinkWrapper">
            <div className="mainMenu-subNavLink"><a target="_blank" href={linkPath} onClick={this.handleAboutLinkClick}>{menuLink.name}</a></div>
          </div>
        </li>
      } else {
        return <li key={menuLink.slug}>
          <div className="mainMenu-subNavLinkWrapper">
            <div className="mainMenu-subNavLink"><Link to={linkPath} onClick={this.handleAboutLinkClick}>{menuLink.name}</Link></div>
          </div>
        </li>
      }

    });

    let menuLinksWrapper = <ul className="mainMenu-subNavList subNavAbout">{menuLinks}</ul>;

    let aboutMenu = '';


    if (aboutMenuState && !browser.greaterThan.desktop) {
      aboutMenu = <div className="mainMenuDropDownInnerWrapper">
        <div className="mainMenuDropDown">{menuLinksWrapper}</div>
      </div>
    } else if (browser.greaterThan.desktop) {
      aboutMenu = <div className="mainMenuDropDownInnerWrapper">
        <div className="mainMenu-subNavPointer">
          <img src="/images/subnav/subnav_pointer_bkgd.png" />
        </div>
        <div className="mainMenuDropDown">{menuLinksWrapper}</div>
      </div>
    }


    return(
      <div>
        {aboutMenu}
      </div>
    );
  }
}

MenuAbout.propTypes = {
  aboutMenuState: PropTypes.bool.isRequired,
  parentCloseFuncCall: PropTypes.func.isRequired,
  browser: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/header/MenuAbout.jsx